import { render, staticRenderFns } from "./LinkedinLogo.vue?vue&type=template&id=ba1e42e2&"
import script from "./LinkedinLogo.vue?vue&type=script&lang=js&"
export * from "./LinkedinLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports